<div class="d-flex align-items-center dropdown mobile-user-info" bsDropdown>
  <div class="d-flex align-items-center clickable" dropdownToggle>
    <img src="/assets/images/home-header-menu.svg" alt="" class="home-header-menu" />
  </div>
  <ul *dropdownMenu class="dropdown-menu dropdown-menu-right note" role="menu">
    <li class="divider dropdown-divider"></li>
    <li class="d-flex align-items-center px-4 py-1">
      <gcc-user-ava [user]="user" size="lg"></gcc-user-ava>
      <div class="px-3">
        <div class="note semibold">{{ user.fullName }}</div>
        <div class="caption text-lightgray">{{ user.jobTitle }}</div>
      </div>
    </li>
    <li class="divider dropdown-divider"></li>
    <li role="menuitem">
      <button type="button" class="btn btn-link d-flex align-items-center px-4 py-2 dropdown-item">
        <i class="icon icon-country icon-16 mr-3"></i>
        <span class="flex-grow-1"> {{ 'header.user_info.language' | translate }}</span>
        <span>{{ 'header.user_info.eng' | translate }}</span>
      </button>
    </li>
    <li role="menuitem">
      <a class="d-flex align-items-center px-4 py-2 dropdown-item" [href]="mailtoLink">
        <i class="icon icon-comment-no-dots icon-16 mr-3"></i>
        <span> {{ 'header.user_info.send_feedback' | translate }}</span>
      </a>
    </li>
    <li class="divider dropdown-divider"></li>
    <li role="menuitem">
      <a
        class="d-flex align-items-center px-4 py-2 dropdown-item"
        target="_blank"
        href="https://deloittenet.deloitte.com/system/pages/Use.aspx"
      >
        <i class="icon icon-document icon-16 mr-3"></i>
        <span> {{ 'header.user_info.terms_of_use' | translate }}</span>
      </a>
    </li>
    <li role="menuitem">
      <a
        class="d-flex align-items-center px-4 py-2 dropdown-item"
        target="_blank"
        href="https://deloittenet.deloitte.com/system/Pages/Personnel_Privacy_Notice.aspx"
      >
        <i class="icon icon-shield icon-16 mr-3"></i>
        <span> {{ 'header.user_info.privacy_policy' | translate }}</span>
      </a>
    </li>
    <li role="menuitem">
      <a class="d-flex align-items-center px-4 py-2 dropdown-item" [routerLink]="['/about']">
        <img class="about-solve-it mr-3" src="assets/images/about-solveIt.svg" />
        <span> {{ 'home.about' | translate }}</span>
      </a>
    </li>
    <li class="divider dropdown-divider mx-4"></li>
    <li role="menuitem">
      <button type="button" class="btn btn-link d-flex align-items-center px-4 py-2 dropdown-item" (click)="onLogout()">
        <i class="icon icon-exit icon-16 mr-3"></i>
        <span> {{ 'header.user_info.sign_out' | translate }}</span>
      </button>
    </li>
  </ul>
</div>
